"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lumaDiff = void 0;
var colord_1 = require("colord");
var a11y_1 = __importDefault(require("colord/plugins/a11y"));
var names_1 = __importDefault(require("colord/plugins/names"));
var mix_1 = __importDefault(require("colord/plugins/mix"));
(0, colord_1.extend)([a11y_1.default, names_1.default, mix_1.default]);
var COLORS = {
    slate: "#47535D",
    midnight: "#242C39",
    white: "#ffffff",
    black: "#000000",
};
var THRESHOLDS = {
    ui: 3,
    text: 4.5,
};
var OPACITY = {
    min: 0,
    max: 1,
};
var lumaDiff = function (backgroundColor, foregroundColor) {
    return (0, colord_1.colord)(foregroundColor).contrast(backgroundColor);
};
exports.lumaDiff = lumaDiff;
var goldilocks = function (backgroundColor, foreground) {
    var _a, _b;
    var minContrast = THRESHOLDS[foreground.type];
    var preferredColors = __spreadArray(__spreadArray([
        foreground.color
    ], __read(((_a = foreground.alternatives) !== null && _a !== void 0 ? _a : [])), false), [
        COLORS.slate,
        COLORS.midnight,
        COLORS.white,
    ], false);
    var color = (_b = preferredColors.find(function (color) { return color !== undefined && (0, exports.lumaDiff)(backgroundColor, color) > minContrast; })) !== null && _b !== void 0 ? _b : COLORS.black;
    if (foreground.opacity !== undefined) {
        var opacity = accessibleFade(backgroundColor, { color: color, opacity: foreground.opacity }, minContrast);
        return (0, colord_1.colord)(backgroundColor).mix(color, opacity).toHex();
    }
    return color;
};
var accessibleFade = function (backgroundColor, foreground, minContrast) {
    var incrementPercentage = 0.05;
    var increment = incrementPercentage * OPACITY.max;
    var opacity = Math.min(Math.max(foreground.opacity, OPACITY.min), OPACITY.max);
    while (opacity < OPACITY.max) {
        var color = (0, colord_1.colord)(backgroundColor).mix(foreground.color, opacity).toHex();
        if ((0, exports.lumaDiff)(backgroundColor, color) > minContrast) {
            return opacity;
        }
        opacity += increment;
    }
    return OPACITY.max;
};
exports.default = goldilocks;
